/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getConfig.defs'
export { main as default } from './getConfig.defs'
